import { render, staticRenderFns } from "./InvestmentProfile.vue?vue&type=template&id=fd6b8302&scoped=true&"
import script from "./InvestmentProfile.vue?vue&type=script&lang=js&"
export * from "./InvestmentProfile.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentProfile.vue?vue&type=style&index=0&id=fd6b8302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6b8302",
  null
  
)

export default component.exports